import React from "react";
import { Radio } from "antd";
import { StyleSheet, Text } from "../../platformComponents";
import { alignItems, colors, flexDirection, fontSize } from "../../styles/common";
import { TCommonRadioProps } from "@adgm/cross-models";

export const CommonRadio: React.FC<TCommonRadioProps> = ({
  value,
  checked,
  label,
  onChange,
  children,
  style,
}) => {
  return (
    <div style={{ ...styles.radio, ...style }}>
      <Radio
        checked={checked}
        value={value}
        onChange={e => {
          onChange?.(e.target.value);
        }}
      />
      {children ?? <Text style={styles.text}>{label}</Text>}
    </div>
  );
};

const styles = StyleSheet.create({
  radio: {
    display: "flex",
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
  },
  text: {
    flex: 1,
    fontSize: fontSize.f16,
    fontFamily: "Common-Regular",
    color: colors.white,
    display: "flex",
    alignItems: "center", // 使用 flexbox 对齐，替代 marginTop
  },
});
